import React, { useEffect } from "react";
import { Form, Input, Button, Spin, Radio, Checkbox } from "antd";
import { ReactSVG } from "react-svg";
import { COMPANY_ACCOUNT_TYPIES } from "../../../../constants";
import { getTranslation } from "../../../../utils/helper";

const PartnerCompanyForm = ({ form, isFetching, company, handleSubmit, handleCancel, setting }) => {
  useEffect(() => {
    if (company) {
      form.setFieldsValue({
        companyName: company?.name,
        accountType: company?.accountType || "",
        name: company?.companyAdmin?.name,
        email: company?.companyAdmin?.email,
        password: null,
        passwordDefault: false,
      });
    }
  }, [company]);

  const onChangeCheckboxPassword = e => {
    if (e.target.checked) {
      form.setFieldsValue({
        password: "123123123",
      });
    }
  };

  return (
    <Spin spinning={isFetching}>
      <div className="CompanyForm">
        <Form
          form={form}
          scrollToFirstError
          layout="vertical"
          hideRequiredMark
          colon={false}
          onFinish={handleSubmit}
          initialValues={{ accountType: "DEFAULT" }}>
          <div className="FormHeader">
            <div className="left">
              {company
                ? getTranslation(setting, "Companies", "Edit Sub Account")
                : getTranslation(setting, "Companies", "Create Sub Account")}
            </div>
          </div>
          <div className="FormContent">
            <Form.Item
              label={getTranslation(setting, "Companies", "Company Name")}
              name="companyName"
              rules={[{ required: true, message: "Required" }]}>
              <Input size="large" placeholder={getTranslation(setting, "Companies", "Company Name")} />
            </Form.Item>
            <Form.Item
              label={getTranslation(setting, "Companies", "Branding")}
              name="accountType"
              rules={[{ required: true, message: "Required" }]}>
              <Radio.Group>
                {COMPANY_ACCOUNT_TYPIES.map(item => (
                  <Radio key={item.value} value={item.value}>
                    {item.name}
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item>
            <Form.Item
              label={getTranslation(setting, "Users", "Name")}
              name="name"
              rules={[{ required: true, message: "Required" }]}>
              <Input size="large" placeholder={getTranslation(setting, "Users", "Name")} />
            </Form.Item>
            <Form.Item
              label={getTranslation(setting, "Users", "Email")}
              name="email"
              rules={[
                { type: "email", message: "Invalid Email" },
                { required: true, message: "Required" },
              ]}>
              <Input size="large" placeholder={getTranslation(setting, "Users", "Email")} />
            </Form.Item>
            <Form.Item
              label={getTranslation(setting, "Users", "Password")}
              name="password"
              rules={[{ required: !company, message: "Required" }]}>
              <Input.Password size="large" placeholder={getTranslation(setting, "Users", "Password")} />
            </Form.Item>
            <Form.Item name="passwordDefault" valuePropName="checked">
              <Checkbox onChange={e => onChangeCheckboxPassword(e)}>
                {getTranslation(setting, "Users", "Use default password")}: <b>123123123</b>
              </Checkbox>
            </Form.Item>
          </div>
          <div className="FormFooter">
            <div className="Left"></div>
            <div className="Right">
              <Button key="cancel" onClick={handleCancel}>
                {getTranslation(setting, "Common", "Cancel")}
              </Button>
              <Button htmlType="submit" type="primary">
                {company ? getTranslation(setting, "Common", "Update") : getTranslation(setting, "Common", "Create")}
                <ReactSVG className="icon" src="/icons/submit.svg" />
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default PartnerCompanyForm;
